/**
 * Hero Search — Diamond Finder + Guard Ring Match
 * Interactive hero section with mode toggle, file upload, text search, and results carousel
 * Connects to OpenAI Vision + Nivoda inventory via /api/ai-search proxy
 */
(function () {
  'use strict';

  // Detect Korean locale
  var isKo = document.documentElement.lang === 'ko';

  // API URL — reads from data attribute, falls back to diamond-deal.pages.dev
  var heroSlides = document.getElementById('hero-slides');
  var API_URL = (heroSlides && heroSlides.dataset.apiUrl) || 'https://diamond-deal.pages.dev/api/ai-search';

  // Load ring settings from Liquid JSON
  var ringSettings = [];
  try {
    var ringDataEl = document.getElementById('ring-settings-data');
    if (ringDataEl) ringSettings = JSON.parse(ringDataEl.textContent);
  } catch (e) {
    ringSettings = [];
  }

  // ===== Shopify automatic discount (fetched once on init) =====
  var storeDiscountPct = 0;
  var usdToKrwRate = 0;
  fetch('https://diamond-deal.pages.dev/api/store-discount')
    .then(function (r) { return r.json(); })
    .then(function (d) { if (d.discount_pct) storeDiscountPct = d.discount_pct; })
    .catch(function () {});
  if (window.VernCurrency) {
    window.VernCurrency.getUsdToKrw()
      .then(function (rate) { usdToKrwRate = rate; })
      .catch(function () {});
  }

  // ===== Analytics: visitor ID from vern-analytics.liquid =====
  var visitorId = (window.__vernAnalytics && window.__vernAnalytics.visitorId) || null;
  var lastSearchSessionId = null;

  // ===== State =====
  var recommendations = [];
  var guardRingRecommendations = [];
  var diamondAnalysis = null;
  var guardAnalysis = null;
  var isFallback = false;
  var matchedRings = [];

  var perPage = 3;
  var totalPages = 0;
  var carouselIdx = 0;
  var ringCarouselIdx = 0;
  var ringTotalPages = 0;
  var files = [];
  var previews = [];
  var guardRingFile = null;
  var guardHandFile = null;
  var selectedGuardRing = null;
  var mobileModeQuery = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
  var modeOrder = getModeOrder();
  var activeMode = getDefaultMode();
  var swipeStartX = 0;
  var swipeStartY = 0;
  var swipePointerId = null;

  // ===== DOM elements — Diamond Finder =====
  var heroPhase = document.getElementById('hero-phase');
  var searchPhase = document.getElementById('search-phase');
  var heroCta = document.getElementById('hero-cta');
  var backBtn = document.getElementById('back-btn');
  var uploadZone = document.getElementById('upload-zone');
  var fileInput = document.getElementById('file-input');
  var textInput = document.getElementById('diamond-text');
  var searchBtn = document.getElementById('search-btn');
  var searchBtnText = document.getElementById('search-btn-text');
  var searchProgress = document.getElementById('search-progress');
  var filePreviews = document.getElementById('file-previews');
  var searchResults = document.getElementById('search-results');
  var resultsRow = document.getElementById('results-row');
  var resultsDots = document.getElementById('results-dots');
  var resultsPage = document.getElementById('results-page');
  var prevBtn = document.getElementById('prev-btn');
  var nextBtn = document.getElementById('next-btn');
  var searchCard = document.getElementById('search-card');
  var splitResults = document.getElementById('split-results');

  // ===== DOM elements — Mode Toggle =====
  var modeSlider = document.getElementById('mode-slider');
  var modeJewelryBtn = document.getElementById('mode-jewelry-btn');
  var modeDiamondBtn = document.getElementById('mode-diamond-btn');
  var modeGuardBtn = document.getElementById('mode-guard-btn');
  var modeJewelryPanel = document.getElementById('mode-jewelry');
  var modeDiamondPanel = document.getElementById('mode-diamond');
  var modeGuardPanel = document.getElementById('mode-guard');

  // ===== DOM elements — Guard Ring =====
  var guardRingZone = document.getElementById('guard-ring-zone');
  var guardRingInput = document.getElementById('guard-ring-input');
  var guardRingPreview = document.getElementById('guard-ring-preview');
  var guardRingPreviewImg = document.getElementById('guard-ring-preview-img');
  var guardRingRemove = document.getElementById('guard-ring-remove');
  var guardRingEmpty = document.getElementById('guard-ring-empty');
  var guardHandZone = document.getElementById('guard-hand-zone');
  var guardHandInput = document.getElementById('guard-hand-input');
  var guardHandPreview = document.getElementById('guard-hand-preview');
  var guardHandPreviewImg = document.getElementById('guard-hand-preview-img');
  var guardHandRemove = document.getElementById('guard-hand-remove');
  var guardHandEmpty = document.getElementById('guard-hand-empty');
  var guardSearchBtn = document.getElementById('guard-search-btn');
  var guardSearchBtnText = document.getElementById('guard-search-btn-text');
  var guardSearchProgress = document.getElementById('guard-search-progress');
  var guardResultsLayout = document.getElementById('guard-results-layout');
  var guardResultsGrid = document.getElementById('guard-results-grid');
  var guardPreviewBtn = document.getElementById('guard-preview-btn');
  var guardPreviewContent = document.getElementById('guard-preview-content');
  var guardCarouselPrev = document.getElementById('guard-carousel-prev');
  var guardCarouselNext = document.getElementById('guard-carousel-next');
  var guardCarouselPage = document.getElementById('guard-carousel-page');
  var GUARD_PER_PAGE = 4;
  var guardCarouselIdx = 0;

  if (!heroPhase || !searchPhase) return;

  function isMobileMode() {
    return mobileModeQuery ? mobileModeQuery.matches : window.innerWidth < 750;
  }

  function getModeOrder() {
    return isMobileMode() ? ['jewelry', 'diamond', 'guard'] : ['diamond', 'guard'];
  }

  function getDefaultMode() {
    return isMobileMode() ? 'jewelry' : 'diamond';
  }

  function getSearchOpenMode() {
    return getDefaultMode();
  }

  function syncModeForViewport() {
    modeOrder = getModeOrder();
    if (modeOrder.indexOf(activeMode) === -1) {
      activeMode = getDefaultMode();
    }
    switchMode(activeMode);
  }

  // ===== Utility: File → base64 data URL =====
  function fileToBase64(file) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.onload = function () { resolve(reader.result); };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  // ===== Utility: Compress image via canvas =====
  function compressImage(dataUrl, maxWidth) {
    maxWidth = maxWidth || 1600;
    return new Promise(function (resolve) {
      var img = new Image();
      img.onload = function () {
        if (img.width <= maxWidth) {
          resolve(dataUrl);
          return;
        }
        var scale = maxWidth / img.width;
        var canvas = document.createElement('canvas');
        canvas.width = maxWidth;
        canvas.height = Math.round(img.height * scale);
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        resolve(canvas.toDataURL('image/jpeg', 0.85));
      };
      img.onerror = function () { resolve(dataUrl); };
      img.src = dataUrl;
    });
  }

  // ===== Utility: Show error message =====
  function showSearchError(message, targetEl) {
    var el = targetEl || searchResults;
    if (!el) return;
    el.style.display = 'block';
    el.innerHTML =
      '<div class="hero-search__error">' +
        '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path stroke-linecap="round" d="M12 8v4m0 4h.01"/></svg>' +
        '<p>' + message + '</p>' +
      '</div>';
  }

  function formatKrw(amount) {
    return new Intl.NumberFormat('ko-KR', {
      style: 'currency',
      currency: 'KRW',
      maximumFractionDigits: 0
    }).format(amount);
  }

  function usdCentsToKrw(priceInCents) {
    var rate = usdToKrwRate || (window.VernCurrency && window.VernCurrency.peekUsdToKrw()) || 0;
    return Math.round((priceInCents / 100) * rate);
  }

  // ===== Utility: Format price (Nivoda returns USD cents) =====
  function formatPrice(priceInCents) {
    var priceKrw = usdCentsToKrw(priceInCents);
    var retailKrw = Math.round(priceKrw * 1.35);
    return '<span class="hero-search__price-original">' + formatKrw(retailKrw) + '</span>' +
           '<span class="hero-search__price-sale">' + formatKrw(priceKrw) + '</span>';
  }

  // ===== Utility: Title-case shape (ROUND → Round, EMERALD → Emerald) =====
  function titleCase(str) {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  // ===== Utility: Build Ring Studio URL with analysis filter params =====
  // opts: { settingId, settingVariantId, ringHandle }
  function buildRingStudioUrl(analysis, stage, opts) {
    opts = opts || {};
    var shape = '';
    var labGrown = true;
    var isGuard = analysis && analysis.estimated_center_shape;

    if (isGuard) {
      shape = (analysis.estimated_center_shape || 'round').toLowerCase();
    } else if (analysis && analysis.shape) {
      shape = (analysis.shape || 'round').toLowerCase();
    }

    // Derive styles from ring handle (e.g. "solitaire-engagement-ring" → "solitaire")
    var styleKeywords = ['solitaire', 'halo', 'pave', 'three-stone', 'vintage', 'cluster', 'bezel', 'tension'];
    var stylesParam = '';
    if (opts.ringHandle) {
      var handleLower = opts.ringHandle.toLowerCase();
      for (var si = 0; si < styleKeywords.length; si++) {
        if (handleLower.indexOf(styleKeywords[si]) !== -1) {
          stylesParam = styleKeywords[si];
          break;
        }
      }
    }

    // Always lab grown — natural diamonds not sold here
    var tabParam = 'Lab+Grown';
    var resolvedStage = stage || 'Add+Diamond';
    // isSWS=true means "Start With Setting" — required when landing on Select+Setting stage
    var isSWS = (resolvedStage === 'Select+Setting') ? 'true' : 'false';
    var url = '/pages/ring-studio?stage=' + resolvedStage
      + '&isSWS=' + isSWS
      + '&activeTab=' + tabParam
      + '&queryLabGrown=true';

    // Ring Studio reads 'settingId'+'settingVariantId' AND 'id'+'variant' to fully render the setting detail
    if (opts.settingId) {
      url += '&settingId=' + opts.settingId + '&id=' + opts.settingId;
    }
    if (opts.settingVariantId) {
      url += '&settingVariantId=' + opts.settingVariantId + '&variant=' + opts.settingVariantId;
    }
    if (stylesParam) url += '&styles=' + stylesParam;
    if (shape) url += '&shapes=' + shape.toLowerCase();

    // Add filter params from analysis
    if (analysis) {
      if (analysis.carat_min) url += '&carats_min=' + analysis.carat_min;
      if (analysis.carat_max) url += '&carats_max=' + analysis.carat_max;

      var colors = isGuard ? analysis.recommended_colors : analysis.color;
      if (colors && colors.length > 0) {
        url += '&color_min=' + encodeURIComponent(colors[colors.length - 1]);
        url += '&color_max=' + encodeURIComponent(colors[0]);
      }

      var clarity = isGuard ? analysis.recommended_clarity : analysis.clarity;
      if (clarity && clarity.length > 0) {
        url += '&clarity_min=' + encodeURIComponent(clarity[clarity.length - 1]);
        url += '&clarity_max=' + encodeURIComponent(clarity[0]);
      }

      var cuts = analysis.cut;
      if (cuts && cuts.length > 0) {
        url += '&cut_min=' + encodeURIComponent(cuts[cuts.length - 1]);
        url += '&cut_max=' + encodeURIComponent(cuts[0]);
      }

      if (analysis.price_max) {
        url += '&price_min=0&price_max=' + Math.round(analysis.price_max);
      }
    }

    return url;
  }

  // ===== Mode Toggle =====
  function switchMode(mode) {
    if (modeOrder.indexOf(mode) === -1) return;
    activeMode = mode;
    if (modeSlider) modeSlider.dataset.activeMode = mode;

    var buttons = [modeJewelryBtn, modeDiamondBtn, modeGuardBtn];
    buttons.forEach(function (btn) {
      if (!btn) return;
      var isActive = btn.dataset.mode === mode;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    var panels = [modeJewelryPanel, modeDiamondPanel, modeGuardPanel];
    panels.forEach(function (panel) {
      if (!panel) return;
      var isActive = panel.dataset.mode === mode;
      panel.classList.toggle('is-active', isActive);
      panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      try {
        panel.inert = !isActive;
      } catch (e) {}
    });
  }

  function switchModeByDelta(delta) {
    var currentIdx = modeOrder.indexOf(activeMode);
    var nextIdx = Math.max(0, Math.min(modeOrder.length - 1, currentIdx + delta));
    if (nextIdx !== currentIdx) {
      switchMode(modeOrder[nextIdx]);
      if (window.__vernAnalytics) window.__vernAnalytics.track('mode_swipe', { mode: modeOrder[nextIdx] });
    }
  }

  if (modeJewelryBtn) {
    modeJewelryBtn.addEventListener('click', function () {
      switchMode('jewelry');
      if (window.__vernAnalytics) window.__vernAnalytics.track('mode_switch', { mode: 'jewelry' });
    });
  }

  if (modeDiamondBtn) {
    modeDiamondBtn.addEventListener('click', function () {
      switchMode('diamond');
      if (window.__vernAnalytics) window.__vernAnalytics.track('mode_switch', { mode: 'diamond' });
    });
  }
  if (modeGuardBtn) {
    modeGuardBtn.addEventListener('click', function () {
      switchMode('guard');
      if (window.__vernAnalytics) window.__vernAnalytics.track('mode_switch', { mode: 'guard' });
    });
  }

  if (modeSlider) {
    modeSlider.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      var target = e.target;
      if (target && target.closest && target.closest('textarea, input, select')) return;
      swipePointerId = e.pointerId;
      swipeStartX = e.clientX;
      swipeStartY = e.clientY;
    });

    modeSlider.addEventListener('pointerup', function (e) {
      if (!swipeStartX || swipePointerId !== e.pointerId) return;
      var dx = e.clientX - swipeStartX;
      var dy = e.clientY - swipeStartY;
      swipeStartX = 0;
      swipeStartY = 0;
      swipePointerId = null;
      if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy) * 1.35) return;
      switchModeByDelta(dx < 0 ? 1 : -1);
    });

    modeSlider.addEventListener('pointercancel', function () {
      swipeStartX = 0;
      swipeStartY = 0;
      swipePointerId = null;
    });
  }
  syncModeForViewport();

  if (mobileModeQuery) {
    if (mobileModeQuery.addEventListener) {
      mobileModeQuery.addEventListener('change', syncModeForViewport);
    } else if (mobileModeQuery.addListener) {
      mobileModeQuery.addListener(syncModeForViewport);
    }
  }

  // ===== Diamond Finder Logic =====
  function openSearch(mode) {
    if (mode) switchMode(mode);
    if (heroSlides) heroSlides.classList.add('is-search');
    if (window.__vernAnalytics) window.__vernAnalytics.track('hero_search_open', {});
  }

  function showHero() {
    if (heroSlides) heroSlides.classList.remove('is-search');
    setTimeout(function () {
      if (splitResults) splitResults.style.display = 'none';
      if (guardResultsLayout) guardResultsLayout.style.display = 'none';
    }, 700);
  }

  function updateSearchBtnState() {
    var hasContent = (textInput && textInput.value.trim()) || files.length > 0;
    if (searchBtn) searchBtn.disabled = !hasContent;
  }

  function addFiles(newFiles) {
    newFiles.forEach(function (f) {
      files.push(f);
      if (f.type.startsWith('image/')) {
        var reader = new FileReader();
        reader.onload = function (e) {
          previews.push(e.target.result);
          renderFiles();
        };
        reader.readAsDataURL(f);
      } else {
        previews.push('');
        renderFiles();
      }
    });
    updateSearchBtnState();
  }

  function removeFile(idx) {
    files.splice(idx, 1);
    previews.splice(idx, 1);
    renderFiles();
    updateSearchBtnState();
  }

  function renderFiles() {
    if (!filePreviews) return;
    filePreviews.innerHTML = '';
    files.forEach(function (f, i) {
      var item = document.createElement('div');
      item.className = 'hero-search__file-item';

      var thumb = document.createElement('div');
      thumb.className = 'hero-search__file-thumb';
      if (previews[i]) {
        var img = document.createElement('img');
        img.src = previews[i];
        img.alt = '';
        thumb.appendChild(img);
      }
      item.appendChild(thumb);

      var name = document.createElement('span');
      name.className = 'hero-search__file-name';
      name.textContent = f.name;
      item.appendChild(name);

      var removeBtn = document.createElement('button');
      removeBtn.className = 'hero-search__file-remove';
      removeBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" d="M6 18L18 6M6 6l12 12"/></svg>';
      removeBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        removeFile(i);
      });
      item.appendChild(removeBtn);

      filePreviews.appendChild(item);
    });
  }

  // ===== Diamond Search (Real API) =====
  async function doSearch() {
    if (!textInput.value.trim() && files.length === 0) return;
    searchBtn.disabled = true;
    searchBtn.classList.add('is-searching');
    if (splitResults) splitResults.style.display = 'none';
    carouselIdx = 0;
    ringCarouselIdx = 0;

    // Start progress animation — set spinner once, update only % text
    var progress = 0;
    var analyzeText = isKo ? '분석 중' : 'Analyzing';
    var docText = files.length > 0 ? (isKo ? '문서' : 'document') : (isKo ? '요청' : 'request');
    searchBtnText.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" style="animation:hs-spin 1.5s linear infinite"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" opacity="0.2"/><path d="M12 2a10 10 0 0 1 10 10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg> ' + analyzeText + ' ' + docText + '... <span id="search-pct">0</span>%';
    var pctEl = document.getElementById('search-pct');
    var progressInterval = setInterval(function () {
      progress += Math.random() * 8 + 2;
      if (progress > 90) progress = 90;
      searchProgress.style.width = progress + '%';
      if (pctEl) pctEl.textContent = Math.round(progress);
    }, 300);

    try {
      // Prepare base64 images (compressed)
      var imagePromises = [];
      for (var i = 0; i < files.length; i++) {
        if (files[i].type.startsWith('image/')) {
          imagePromises.push(
            fileToBase64(files[i]).then(function (b64) {
              return compressImage(b64);
            })
          );
        }
      }
      var base64Images = await Promise.all(imagePromises);

      // API call
      var response = await fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          action: 'diamondSearch',
          images: base64Images,
          textInput: textInput.value.trim(),
          visitor_id: visitorId
        })
      });

      var data = await response.json();
      clearInterval(progressInterval);

      if (!response.ok || !data.success) {
        throw new Error(data.error || (isKo ? '검색에 실패했습니다' : 'Search failed'));
      }

      // Store results — filter out diamonds without images
      diamondAnalysis = data.analysis;
      recommendations = (data.results.items || []).filter(function (item) {
        return item.diamond && item.diamond.image;
      });
      isFallback = data.fallback || false;
      lastSearchSessionId = data.search_session_id || null;

      // Reorder diamonds: most relevant first, rest by price
      if (recommendations.length > 1 && diamondAnalysis) {
        var bestDiamondIdx = 0;
        var bestDiamondScore = -Infinity;
        recommendations.forEach(function (item, i) {
          var score = scoreDiamondRelevance(item, diamondAnalysis);
          if (score > bestDiamondScore) { bestDiamondScore = score; bestDiamondIdx = i; }
        });
        if (bestDiamondIdx > 0) {
          var best = recommendations.splice(bestDiamondIdx, 1)[0];
          recommendations.unshift(best);
        }
      }

      matchedRings = getMatchedRings();
      totalPages = Math.ceil(recommendations.length / perPage);

      // Finish progress
      searchProgress.style.width = '100%';
      setTimeout(function () {
        searchBtn.classList.remove('is-searching');
        searchProgress.style.width = '0';
        searchBtn.disabled = false;
        showResultsPanel();
        if (splitResults) splitResults.style.display = '';
      }, 300);

    } catch (err) {
      clearInterval(progressInterval);
      searchBtn.classList.remove('is-searching');
      searchProgress.style.width = '0';
      searchBtn.disabled = false;
      if (splitResults) splitResults.style.display = '';
      showSearchError(err.message, searchResults);
    }
  }

  // ===== Score diamond relevance — how closely it matches the AI analysis =====
  function scoreDiamondRelevance(item, analysis) {
    var score = 0;
    var cert = item.diamond && item.diamond.certificate;
    if (!cert || !analysis) return score;

    // Carat: closer to midpoint of estimated range = higher score (max 100)
    if (analysis.carat_min && analysis.carat_max && cert.carats) {
      var mid = (analysis.carat_min + analysis.carat_max) / 2;
      var halfRange = (analysis.carat_max - analysis.carat_min) / 2 || 0.1;
      var dist = Math.abs(cert.carats - mid);
      score += Math.max(0, 100 - (dist / halfRange) * 100);
    }

    // Color: position in analysis color array (first = best, max 50)
    if (analysis.color && analysis.color.length > 0 && cert.color) {
      var colorIdx = analysis.color.indexOf(cert.color);
      if (colorIdx >= 0) {
        score += 50 - (colorIdx / Math.max(analysis.color.length - 1, 1)) * 30;
      }
    }

    // Clarity: position in analysis clarity array (first = best, max 50)
    if (analysis.clarity && analysis.clarity.length > 0 && cert.clarity) {
      var clarityIdx = analysis.clarity.indexOf(cert.clarity);
      if (clarityIdx >= 0) {
        score += 50 - (clarityIdx / Math.max(analysis.clarity.length - 1, 1)) * 30;
      }
    }

    // Cut: position in analysis cut array (first = best, max 30)
    if (analysis.cut && analysis.cut.length > 0 && cert.cut) {
      var cutIdx = analysis.cut.indexOf(cert.cut);
      if (cutIdx >= 0) {
        score += 30 - (cutIdx / Math.max(analysis.cut.length - 1, 1)) * 15;
      }
    }

    return score;
  }

  // ===== Score ring relevance — how closely it matches detected ring info =====
  function scoreRingRelevance(ring, matchStyle, shapeNorm, ringInfo) {
    var score = 0;

    // Style match (most important: +100)
    if (matchStyle && matchesStyle(ring, matchStyle)) score += 100;

    // Shape match (+50)
    if (shapeNorm && matchesShape(ring, shapeNorm)) score += 50;

    // Metal match from ring_info (+30)
    if (ringInfo && ringInfo.metal) {
      var metalLower = ringInfo.metal.toLowerCase();
      var ringText = ((ring.title || '') + ' ' + (ring.handle || '')).toLowerCase();
      if (ring.tags) {
        var tagsStr = Array.isArray(ring.tags) ? ring.tags.join(' ') : String(ring.tags);
        ringText += ' ' + tagsStr.toLowerCase();
      }
      if (metalLower.indexOf('platinum') >= 0 && ringText.indexOf('platinum') >= 0) score += 30;
      else if (metalLower.indexOf('white') >= 0 && ringText.indexOf('white') >= 0) score += 30;
      else if (metalLower.indexOf('yellow') >= 0 && ringText.indexOf('yellow') >= 0) score += 30;
      else if (metalLower.indexOf('rose') >= 0 && ringText.indexOf('rose') >= 0) score += 30;
    }

    return score;
  }

  // ===== Get matching ring settings — style first, then shape, sorted by price =====
  // Style keyword mapping for title/handle matching
  var STYLE_KEYWORDS = {
    'Three-Stone': ['three-stone', 'trilogy', 'three stone', '3-stone', '3 stone'],
    'Solitaire': ['solitaire'],
    'Halo': ['halo'],
    'Pavé': ['pave', 'pavé', 'diamond-band', 'diamond band'],
    'Cathedral': ['cathedral'],
    'Channel': ['channel'],
    'Bezel': ['bezel'],
    'Vintage': ['vintage', 'cluster', 'floral'],
    'Cluster': ['cluster'],
  };

  function matchesStyle(ring, style) {
    var keywords = STYLE_KEYWORDS[style];
    if (!keywords) return false;
    var text = ((ring.title || '') + ' ' + (ring.handle || '')).toLowerCase();
    // Also check tags array
    if (ring.tags) {
      var tagsStr = Array.isArray(ring.tags) ? ring.tags.join(' ') : String(ring.tags);
      text += ' ' + tagsStr.toLowerCase();
    }
    return keywords.some(function (kw) { return text.indexOf(kw) >= 0; });
  }

  function matchesShape(ring, shapeNorm) {
    if (!shapeNorm || !ring.shapes || ring.shapes.length === 0) return false;
    return ring.shapes.some(function (s) {
      return s.toLowerCase() === shapeNorm.toLowerCase();
    });
  }

  function getMatchedRings() {
    var matchShape = '';
    var matchStyle = '';

    if (diamondAnalysis) {
      if (diamondAnalysis.shape) matchShape = diamondAnalysis.shape;
      if (diamondAnalysis.ring_info && diamondAnalysis.ring_info.detected && diamondAnalysis.ring_info.style) {
        matchStyle = diamondAnalysis.ring_info.style;
      }
    } else if (recommendations.length > 0) {
      var firstCert = recommendations[0].diamond.certificate;
      if (firstCert && firstCert.shape) matchShape = firstCert.shape;
    }

    var shapeNorm = titleCase(matchShape);
    var result = [];

    // Priority 1: Style + Shape match (most relevant)
    if (matchStyle) {
      result = ringSettings.filter(function (ring) {
        return matchesStyle(ring, matchStyle) && matchesShape(ring, shapeNorm);
      });

      // Priority 2: Style match only (if no shape+style combo)
      if (result.length === 0) {
        result = ringSettings.filter(function (ring) {
          return matchesStyle(ring, matchStyle);
        });
      }
    }

    // Priority 3: Shape match only (no style detected)
    if (result.length === 0 && shapeNorm) {
      result = ringSettings.filter(function (ring) {
        return matchesShape(ring, shapeNorm);
      });
    }

    // Fallback: all rings
    if (result.length === 0) {
      result = ringSettings.slice();
    }

    // Relevance-first: find the best match, put it first, rest by price ASC
    var ringInfo = diamondAnalysis && diamondAnalysis.ring_info ? diamondAnalysis.ring_info : null;
    if (result.length > 1) {
      var bestRingIdx = 0;
      var bestRingScore = -Infinity;
      result.forEach(function (ring, i) {
        var s = scoreRingRelevance(ring, matchStyle, shapeNorm, ringInfo);
        if (s > bestRingScore) { bestRingScore = s; bestRingIdx = i; }
      });
      var bestRing = result.splice(bestRingIdx, 1)[0];
      // Sort remaining by price ascending
      result.sort(function (a, b) { return a.price - b.price; });
      result.unshift(bestRing);
    }

    return result.slice(0, 12);
  }

  function showResultsPanel() {
    var btnLabel = isKo ? '다이아몬드 찾기' : 'Find My Diamond';
    searchBtnText.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><path stroke-linecap="round" d="m21 21-4.35-4.35"/></svg> ' + btnLabel;

    // Diamond count
    var countEl = document.getElementById('results-count');
    if (countEl) countEl.textContent = recommendations.length;

    // Ring count
    var ringCountEl = document.getElementById('ring-results-count');
    if (ringCountEl) ringCountEl.textContent = matchedRings.length;

    // Build diamond subtitle from analysis
    var subText = isKo ? '입력하신 조건 기준' : 'Based on your specifications';
    if (diamondAnalysis) {
      var specParts = [];
      if (diamondAnalysis.shape) specParts.push(diamondAnalysis.shape);
      if (diamondAnalysis.carat_min && diamondAnalysis.carat_max) {
        specParts.push(diamondAnalysis.carat_min.toFixed(1) + '-' + diamondAnalysis.carat_max.toFixed(1) + 'ct');
      }
      if (diamondAnalysis.color && diamondAnalysis.color.length > 0) {
        specParts.push(diamondAnalysis.color[0] + '-' + diamondAnalysis.color[diamondAnalysis.color.length - 1]);
      }
      if (diamondAnalysis.clarity && diamondAnalysis.clarity.length > 0) {
        specParts.push(diamondAnalysis.clarity[0] + '-' + diamondAnalysis.clarity[diamondAnalysis.clarity.length - 1]);
      }
      if (specParts.length > 0) subText = specParts.join(' · ');
    }
    if (isFallback && diamondAnalysis && diamondAnalysis.shape) {
      subText = (isKo ? diamondAnalysis.shape + ' 셰이프 기준 추천' : diamondAnalysis.shape + ' shape recommendations');
    }
    var subEl = document.getElementById('diamond-sub');
    if (subEl) subEl.textContent = subText;

    // Ring subtitle — show style + shape
    var shapeNorm = diamondAnalysis && diamondAnalysis.shape ? titleCase(diamondAnalysis.shape) : '';
    var ringStyle = diamondAnalysis && diamondAnalysis.ring_info && diamondAnalysis.ring_info.detected && diamondAnalysis.ring_info.style ? diamondAnalysis.ring_info.style : '';
    var ringSub = document.getElementById('ring-sub');
    if (ringSub) {
      if (ringStyle && shapeNorm) {
        ringSub.textContent = isKo ? shapeNorm + ' · ' + ringStyle + ' 세팅' : shapeNorm + ' · ' + ringStyle + ' settings';
      } else if (ringStyle) {
        ringSub.textContent = isKo ? ringStyle + ' 세팅' : ringStyle + ' settings';
      } else if (shapeNorm) {
        ringSub.textContent = isKo ? shapeNorm + ' 셰이프 매칭' : shapeNorm + ' shape matching';
      } else {
        ringSub.textContent = isKo ? '매칭 링 세팅' : 'Matching ring settings';
      }
    }

    // Re-grab DOM refs — diamonds
    resultsRow = document.getElementById('results-row');
    resultsDots = document.getElementById('results-dots');
    prevBtn = document.getElementById('prev-btn');
    nextBtn = document.getElementById('next-btn');
    resultsPage = document.getElementById('results-page');

    // DOM refs — rings
    var ringResultsRow = document.getElementById('ring-results-row');
    var ringResultsDots = document.getElementById('ring-results-dots');
    var ringPrevBtn = document.getElementById('ring-prev-btn');
    var ringNextBtn = document.getElementById('ring-next-btn');
    var ringResultsPage = document.getElementById('ring-results-page');

    // Ring carousel state
    ringCarouselIdx = 0;
    ringTotalPages = Math.ceil(matchedRings.length / perPage);

    // Diamond nav
    if (prevBtn) {
      prevBtn.onclick = function () {
        carouselIdx = Math.max(0, carouselIdx - 1);
        renderDiamondCards();
        renderDots(resultsDots, totalPages, carouselIdx, 'diamond');
        updateDiamondNav();
      };
    }
    if (nextBtn) {
      nextBtn.onclick = function () {
        carouselIdx = Math.min(totalPages - 1, carouselIdx + 1);
        renderDiamondCards();
        renderDots(resultsDots, totalPages, carouselIdx, 'diamond');
        updateDiamondNav();
      };
    }

    // Ring nav
    if (ringPrevBtn) {
      ringPrevBtn.onclick = function () {
        ringCarouselIdx = Math.max(0, ringCarouselIdx - 1);
        renderRingCards(ringResultsRow);
        renderDots(ringResultsDots, ringTotalPages, ringCarouselIdx, 'ring');
        updateRingNav(ringResultsPage, ringPrevBtn, ringNextBtn);
      };
    }
    if (ringNextBtn) {
      ringNextBtn.onclick = function () {
        ringCarouselIdx = Math.min(ringTotalPages - 1, ringCarouselIdx + 1);
        renderRingCards(ringResultsRow);
        renderDots(ringResultsDots, ringTotalPages, ringCarouselIdx, 'ring');
        updateRingNav(ringResultsPage, ringPrevBtn, ringNextBtn);
      };
    }

    renderDiamondCards();
    renderRingCards(ringResultsRow);
    renderDots(resultsDots, totalPages, carouselIdx, 'diamond');
    renderDots(ringResultsDots, ringTotalPages, ringCarouselIdx, 'ring');
    updateDiamondNav();
    updateRingNav(ringResultsPage, ringPrevBtn, ringNextBtn);
  }

  // ===== Render diamond cards =====
  function renderDiamondCards() {
    if (!resultsRow) return;
    var start = carouselIdx * perPage;
    var visibleDiamonds = recommendations.slice(start, start + perPage);

    resultsRow.innerHTML = '';

    visibleDiamonds.forEach(function (item, i) {
      var d = item.diamond;
      var cert = d.certificate;

      var shapeDisplay = titleCase(cert.shape);
      var priceKrw = usdCentsToKrw(item.price);

      // Skip diamonds over 3M KRW — only sell combos under that threshold
      if (priceKrw > 3000000) return;

      var salePrice = storeDiscountPct > 0 ? Math.round(priceKrw * (1 - storeDiscountPct / 100)) : priceKrw;
      var card = document.createElement('div');
      card.className = 'hero-search__result-card';
      card.style.animation = 'hs-fadeSlideUp 0.4s ' + (i * 0.06) + 's ease-out both';
      var labDisplay = cert.lab || 'IGI';

      var imgHtml = d.image
        ? '<img src="' + d.image + '" alt="' + shapeDisplay + ' Diamond" loading="lazy" />'
        : '<svg viewBox="0 0 80 80" fill="none"><path d="M40 8L12 32L24 68H56L68 32L40 8Z" stroke="currentColor" stroke-width="1.5"/></svg>';

      var specStr = [cert.color, cert.clarity, cert.cut].filter(Boolean).join(', ');
      var nameStr = (isKo ? '랩 다이아몬드 ' : 'Lab Diamond ') + (cert.carats || '') + 'Ct ' + shapeDisplay;

      card.innerHTML =
        '<div class="hero-search__result-visual">' +
          imgHtml +
          (storeDiscountPct > 0 ? '<span class="hero-search__result-badge hero-search__result-badge--discount">-' + storeDiscountPct + '%</span>' : '') +
          '<span class="hero-search__result-badge hero-search__result-badge--cert">' + labDisplay + '</span>' +
        '</div>' +
        '<div class="hero-search__result-info">' +
          '<p class="hero-search__result-cert">Lab Grown</p>' +
          '<h4 class="hero-search__result-name">' + nameStr + '</h4>' +
          '<p class="hero-search__result-spec">' + specStr + '</p>' +
          '<div class="hero-search__result-footer">' +
            (storeDiscountPct > 0 ? '<span class="hero-search__price-original">' + formatKrw(priceKrw) + '</span>' : '') +
            '<span class="hero-search__price-sale">' + formatKrw(salePrice) + '</span>' +
            '<span class="hero-search__result-view">' + (isKo ? '자세히 보기' : 'View Details') + ' <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3"/></svg></span>' +
          '</div>' +
        '</div>';

      (function (diamondId, offerId, shape, carats, priceCents) {
        card.addEventListener('click', function () {
          if (window.__vernAnalytics) {
            window.__vernAnalytics.track('diamond_card_click', {
              diamond_id: offerId,
              shape: shape,
              carats: carats,
              price_cents: priceCents,
              search_session_id: lastSearchSessionId
            });
          }
          window.open('/collections/lab-grown-diamonds?id=' + encodeURIComponent(diamondId) + '&stoneType=diamond', '_blank');
        });
      })(d.id, item.id, cert.shape, cert.carats, item.price);

      resultsRow.appendChild(card);
    });
  }

  // ===== Render ring setting cards =====
  function renderRingCards(container) {
    if (!container) return;
    var start = ringCarouselIdx * perPage;
    var visibleRings = matchedRings.slice(start, start + perPage);
    var shapeNorm = diamondAnalysis && diamondAnalysis.shape ? titleCase(diamondAnalysis.shape) : '';

    container.innerHTML = '';

    visibleRings.forEach(function (ring, i) {
      var card = document.createElement('div');
      card.className = 'hero-search__result-card hero-search__ring-card';
      card.style.animation = 'hs-fadeSlideUp 0.4s ' + (i * 0.06) + 's ease-out both';

      // ring.price is Shopify price in KRW minor units (100 = ₩1)
      var ringKrw = Math.round(ring.price / 100);

      // Skip rings over 3M KRW
      if (ringKrw > 3000000) return;

      var ringSalePrice = storeDiscountPct > 0 ? Math.round(ringKrw * (1 - storeDiscountPct / 100)) : ringKrw;

      var imgHtml = ring.image
        ? '<img src="' + ring.image + '" alt="' + ring.title + '" loading="lazy" />'
        : '<svg viewBox="0 0 80 80" fill="none"><circle cx="40" cy="40" r="28" stroke="currentColor" stroke-width="1.5"/><circle cx="40" cy="40" r="16" stroke="currentColor" stroke-width="1" opacity="0.5"/></svg>';

      card.innerHTML =
        '<div class="hero-search__result-visual">' +
          imgHtml +
          (storeDiscountPct > 0 ? '<span class="hero-search__result-badge hero-search__result-badge--discount">-' + storeDiscountPct + '%</span>' : '') +
          '<span class="hero-search__result-badge hero-search__result-badge--ring">' + (isKo ? '세팅' : 'Setting') + '</span>' +
        '</div>' +
        '<div class="hero-search__result-info">' +
          '<p class="hero-search__result-cert">' + (isKo ? '링 세팅' : 'Ring Setting') + '</p>' +
          '<h4 class="hero-search__result-name">' + ring.title + '</h4>' +
          '<p class="hero-search__result-spec">' + (shapeNorm || 'All') + ' · ' + (isKo ? '14K/18K' : '14K/18K') + '</p>' +
          '<div class="hero-search__result-footer">' +
            (storeDiscountPct > 0 ? '<span class="hero-search__price-original">' + formatKrw(ringKrw) + '</span>' : '') +
            '<span class="hero-search__price-sale">' + formatKrw(ringSalePrice) + '</span>' +
            '<span class="hero-search__result-view">' + (isKo ? '보기' : 'View') + ' <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3"/></svg></span>' +
          '</div>' +
        '</div>';

      card.addEventListener('click', function () {
        if (window.__vernAnalytics) {
          window.__vernAnalytics.track('ring_card_click', {
            ring_id: ring.id,
            ring_title: ring.title,
            search_session_id: lastSearchSessionId
          });
        }
        window.open(buildRingStudioUrl(diamondAnalysis, 'Add+Diamond', {
          settingId: ring.id,
          settingVariantId: ring.variantId,
          ringHandle: ring.handle
        }), '_blank');
      });

      container.appendChild(card);
    });
  }

  // ===== Render dots (shared for both carousels) =====
  function renderDots(dotsContainer, pages, activeIdx, type) {
    if (!dotsContainer) return;
    dotsContainer.innerHTML = '';
    for (var i = 0; i < pages; i++) {
      var dot = document.createElement('button');
      dot.className = 'hero-search__dot' + (i === activeIdx ? ' is-active' : '');
      dot.dataset.idx = i;
      dot.addEventListener('click', function () {
        var idx = parseInt(this.dataset.idx);
        if (type === 'ring') {
          ringCarouselIdx = idx;
          renderRingCards(document.getElementById('ring-results-row'));
          renderDots(dotsContainer, pages, ringCarouselIdx, 'ring');
          updateRingNav(document.getElementById('ring-results-page'), document.getElementById('ring-prev-btn'), document.getElementById('ring-next-btn'));
        } else {
          carouselIdx = idx;
          renderDiamondCards();
          renderDots(dotsContainer, pages, carouselIdx, 'diamond');
          updateDiamondNav();
        }
      });
      dotsContainer.appendChild(dot);
    }
  }

  function updateDiamondNav() {
    if (resultsPage) resultsPage.textContent = (carouselIdx + 1) + '/' + totalPages;
    if (prevBtn) prevBtn.disabled = carouselIdx === 0;
    if (nextBtn) nextBtn.disabled = carouselIdx >= totalPages - 1;
  }

  function updateRingNav(pageEl, prevEl, nextEl) {
    if (pageEl) pageEl.textContent = (ringCarouselIdx + 1) + '/' + ringTotalPages;
    if (prevEl) prevEl.disabled = ringCarouselIdx === 0;
    if (nextEl) nextEl.disabled = ringCarouselIdx >= ringTotalPages - 1;
  }

  // ===== Guard Ring Logic =====
  function updateGuardSearchBtnState() {
    if (guardSearchBtn) guardSearchBtn.disabled = !guardRingFile;
  }

  // Helper: extract image file from clipboard event
  function getImageFromClipboard(e) {
    var items = (e.clipboardData || e.originalEvent && e.originalEvent.clipboardData || {}).items;
    if (!items) return null;
    for (var i = 0; i < items.length; i++) {
      if (items[i].type.indexOf('image/') === 0) {
        return items[i].getAsFile();
      }
    }
    return null;
  }

  function handleGuardUpload(zone, input, previewEl, previewImg, emptyEl, rmBtn, type) {
    if (!zone) return;

    // Make zone focusable for paste events
    if (!zone.getAttribute('tabindex')) zone.setAttribute('tabindex', '0');

    zone.addEventListener('click', function (e) {
      if (e.target.closest('.guard-upload-zone__remove')) return;
      input.click();
    });

    zone.addEventListener('dragover', function (e) {
      e.preventDefault();
      zone.classList.add('is-dragover');
    });

    zone.addEventListener('dragleave', function () {
      zone.classList.remove('is-dragover');
    });

    zone.addEventListener('drop', function (e) {
      e.preventDefault();
      zone.classList.remove('is-dragover');
      if (e.dataTransfer.files.length > 0) {
        setGuardFile(type, e.dataTransfer.files[0], previewEl, previewImg, emptyEl);
      }
    });

    // Ctrl+V paste support (zone-level)
    zone.addEventListener('paste', function (e) {
      var file = getImageFromClipboard(e);
      if (file) {
        e.preventDefault();
        e.stopPropagation();
        setGuardFile(type, file, previewEl, previewImg, emptyEl);
      }
    });

    input.addEventListener('change', function () {
      if (input.files && input.files[0]) {
        setGuardFile(type, input.files[0], previewEl, previewImg, emptyEl);
      }
    });

    if (rmBtn) {
      rmBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        clearGuardFile(type, previewEl, emptyEl, input);
      });
    }
  }

  function setGuardFile(type, file, previewEl, previewImg, emptyEl) {
    if (type === 'ring') {
      guardRingFile = file;
    } else {
      guardHandFile = file;
    }

    var reader = new FileReader();
    reader.onload = function (e) {
      previewImg.src = e.target.result;
      previewEl.style.display = '';
      emptyEl.style.display = 'none';
    };
    reader.readAsDataURL(file);

    updateGuardSearchBtnState();
  }

  function clearGuardFile(type, previewEl, emptyEl, input) {
    if (type === 'ring') {
      guardRingFile = null;
    } else {
      guardHandFile = null;
    }

    previewEl.style.display = 'none';
    emptyEl.style.display = '';
    input.value = '';

    updateGuardSearchBtnState();
  }

  // ===== Guard Ring Search (Real API) =====
  async function doGuardSearch() {
    if (!guardRingFile) return;
    guardSearchBtn.disabled = true;
    guardSearchBtn.classList.add('is-searching');
    guardResultsLayout.style.display = 'none';
    selectedGuardRing = null;
    if (guardPreviewBtn) guardPreviewBtn.disabled = true;

    // Start progress animation — set spinner once, update only % text
    var progress = 0;
    var analyzeText = isKo ? '웨딩밴드 분석 중' : 'Analyzing wedding band';
    guardSearchBtnText.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" style="animation:hs-spin 1.5s linear infinite"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" opacity="0.2"/><path d="M12 2a10 10 0 0 1 10 10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg> ' + analyzeText + '... <span id="guard-search-pct">0</span>%';
    var guardPctEl = document.getElementById('guard-search-pct');
    var progressInterval = setInterval(function () {
      progress += Math.random() * 8 + 2;
      if (progress > 90) progress = 90;
      guardSearchProgress.style.width = progress + '%';
      if (guardPctEl) guardPctEl.textContent = Math.round(progress);
    }, 300);

    try {
      // Prepare images
      var ringB64 = await fileToBase64(guardRingFile);
      ringB64 = await compressImage(ringB64);

      var handB64 = null;
      if (guardHandFile) {
        handB64 = await fileToBase64(guardHandFile);
        handB64 = await compressImage(handB64);
      }

      // API call
      var response = await fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          action: 'guardRingSearch',
          ringImage: ringB64,
          handImage: handB64,
          visitor_id: visitorId
        })
      });

      var data = await response.json();
      clearInterval(progressInterval);

      if (!response.ok || !data.success) {
        throw new Error(data.error || (isKo ? '분석에 실패했습니다' : 'Analysis failed'));
      }

      // Store results — use ring settings matched to guard ring analysis
      guardAnalysis = data.analysis;
      guardRingRecommendations = getMatchedRingsForGuard(data.analysis);
      lastSearchSessionId = data.search_session_id || null;

      // Finish progress
      guardSearchProgress.style.width = '100%';
      setTimeout(function () {
        guardSearchBtn.classList.remove('is-searching');
        guardSearchProgress.style.width = '0';
        guardSearchBtn.disabled = false;
        if (guardRingRecommendations.length > 0) {
          showGuardResults();
        } else {
          // Show inline error
          guardResultsLayout.style.display = '';
          guardResultsGrid.innerHTML =
            '<div class="hero-search__error">' +
              '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path stroke-linecap="round" d="M12 8v4m0 4h.01"/></svg>' +
              '<p>' + (isKo ? '조건에 맞는 다이아몬드를 찾지 못했습니다.' : 'No matching diamonds found.') + '</p>' +
            '</div>';
        }
      }, 300);

    } catch (err) {
      clearInterval(progressInterval);
      guardSearchBtn.classList.remove('is-searching');
      guardSearchProgress.style.width = '0';
      guardSearchBtn.disabled = false;
      guardResultsLayout.style.display = '';
      guardResultsGrid.innerHTML =
        '<div class="hero-search__error">' +
          '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path stroke-linecap="round" d="M12 8v4m0 4h.01"/></svg>' +
          '<p>' + err.message + '</p>' +
        '</div>';
    }
  }

  function getMatchedRingsForGuard(analysis) {
    var matchShape = analysis.estimated_center_shape || '';
    var matchStyle = analysis.ring_style || '';
    var shapeNorm = titleCase(matchShape);
    var result = [];

    if (matchStyle) {
      result = ringSettings.filter(function (ring) {
        return matchesStyle(ring, matchStyle) && matchesShape(ring, shapeNorm);
      });
      if (result.length === 0) {
        result = ringSettings.filter(function (ring) {
          return matchesStyle(ring, matchStyle);
        });
      }
    }
    if (result.length === 0 && shapeNorm) {
      result = ringSettings.filter(function (ring) {
        return matchesShape(ring, shapeNorm);
      });
    }
    if (result.length === 0) result = ringSettings.slice();

    result.sort(function (a, b) { return a.price - b.price; });
    return result;
  }

  function showGuardResults() {
    var btnLabel = isKo ? '어울리는 링 찾기' : 'Find Matching Rings';
    guardSearchBtnText.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><path stroke-linecap="round" d="m21 21-4.35-4.35"/></svg> ' + btnLabel;
    guardResultsLayout.style.display = '';

    var countEl = document.getElementById('guard-results-count');
    if (countEl) countEl.textContent = guardRingRecommendations.length;

    guardCarouselIdx = 0;
    renderGuardResults();

    // Show AI analysis in preview panel
    if (guardAnalysis && guardPreviewContent) {
      var notesHtml = '';
      if (guardAnalysis.ring_style) notesHtml += '<div class="guard-preview-panel__analysis-item"><strong>' + (isKo ? '스타일' : 'Style') + ':</strong> ' + guardAnalysis.ring_style + '</div>';
      if (guardAnalysis.metal_color) notesHtml += '<div class="guard-preview-panel__analysis-item"><strong>' + (isKo ? '메탈' : 'Metal') + ':</strong> ' + guardAnalysis.metal_color + '</div>';
      if (guardAnalysis.estimated_center_shape) notesHtml += '<div class="guard-preview-panel__analysis-item"><strong>' + (isKo ? '추천 셰이프' : 'Recommended Shape') + ':</strong> ' + guardAnalysis.estimated_center_shape + '</div>';
      if (guardAnalysis.carat_min && guardAnalysis.carat_max) notesHtml += '<div class="guard-preview-panel__analysis-item"><strong>' + (isKo ? '캐럿 범위' : 'Carat Range') + ':</strong> ' + guardAnalysis.carat_min.toFixed(1) + ' - ' + guardAnalysis.carat_max.toFixed(1) + 'ct</div>';
      if (guardAnalysis.style_notes) notesHtml += '<div class="guard-preview-panel__analysis-notes">' + guardAnalysis.style_notes + '</div>';

      guardPreviewContent.innerHTML =
        '<div class="guard-preview-panel__analysis">' +
          '<div class="guard-preview-panel__analysis-title">' +
            '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path stroke-linecap="round" stroke-linejoin="round" d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09Z"/></svg>' +
            ' ' + (isKo ? 'AI 분석 결과' : 'AI Analysis') +
          '</div>' +
          notesHtml +
        '</div>';
    }
  }

  function renderGuardResults() {
    if (!guardResultsGrid) return;
    guardResultsGrid.innerHTML = '';

    var totalPages = Math.ceil(guardRingRecommendations.length / GUARD_PER_PAGE);
    var start = guardCarouselIdx * GUARD_PER_PAGE;
    var pageItems = guardRingRecommendations.slice(start, start + GUARD_PER_PAGE);

    pageItems.forEach(function (ring) {
      var card = document.createElement('div');
      card.className = 'hero-search__result-card';
      card.dataset.id = ring.id;

      // Keep selected state
      if (ring.id === selectedGuardRing) card.classList.add('is-selected');

      var priceKrw = Math.round(ring.price / 100);
      var salePrice = storeDiscountPct > 0 ? Math.round(priceKrw * (1 - storeDiscountPct / 100)) : priceKrw;

      var imgHtml = ring.image
        ? '<img src="' + ring.image + '" alt="' + ring.title + '" loading="lazy" />'
        : '<svg viewBox="0 0 80 80" fill="none"><circle cx="40" cy="40" r="28" stroke="currentColor" stroke-width="1.5"/></svg>';

      card.innerHTML =
        '<div class="hero-search__result-visual">' +
          imgHtml +
          (storeDiscountPct > 0 ? '<span class="hero-search__result-badge hero-search__result-badge--discount">-' + storeDiscountPct + '%</span>' : '') +
        '</div>' +
        '<div class="hero-search__result-info">' +
          '<p class="hero-search__result-cert">' + (isKo ? '반지 세팅' : 'Ring Setting') + '</p>' +
          '<h4 class="hero-search__result-name">' + ring.title + '</h4>' +
          '<div class="hero-search__result-footer">' +
            (storeDiscountPct > 0 ? '<span class="hero-search__price-original">' + formatKrw(priceKrw) + '</span>' : '') +
            '<span class="hero-search__price-sale">' + formatKrw(salePrice) + '</span>' +
            '<span class="hero-search__result-view">' + (isKo ? '선택' : 'Select') + ' <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3"/></svg></span>' +
          '</div>' +
        '</div>';

      card.addEventListener('click', function () {
        selectGuardRing(ring.id, card);
      });

      guardResultsGrid.appendChild(card);
    });

    // Update nav
    if (guardCarouselPage) guardCarouselPage.textContent = (guardCarouselIdx + 1) + ' / ' + (totalPages || 1);
    if (guardCarouselPrev) guardCarouselPrev.disabled = guardCarouselIdx === 0;
    if (guardCarouselNext) guardCarouselNext.disabled = guardCarouselIdx >= totalPages - 1;
  }

  // Carousel nav listeners
  if (guardCarouselPrev) {
    guardCarouselPrev.addEventListener('click', function () {
      if (guardCarouselIdx > 0) { guardCarouselIdx--; renderGuardResults(); }
    });
  }
  if (guardCarouselNext) {
    guardCarouselNext.addEventListener('click', function () {
      var totalPages = Math.ceil(guardRingRecommendations.length / GUARD_PER_PAGE);
      if (guardCarouselIdx < totalPages - 1) { guardCarouselIdx++; renderGuardResults(); }
    });
  }

  // Cache: ringId → { imageB64, ringStudioUrl }
  var guardPreviewCache = {};

  function selectGuardRing(id, card) {
    selectedGuardRing = id;

    var allCards = guardResultsGrid.querySelectorAll('.hero-search__result-card');
    allCards.forEach(function (c) { c.classList.remove('is-selected'); });
    card.classList.add('is-selected');

    var btn = document.getElementById('guard-preview-btn');
    if (!btn) return;

    if (guardPreviewCache[id]) {
      // Already generated — show cached image + Ring Studio button
      var cached = guardPreviewCache[id];
      guardPreviewContent.innerHTML =
        '<div class="guard-preview-panel__generated">' +
          '<img src="data:image/png;base64,' + cached.imageB64 + '" alt="AI Generated Preview" />' +
        '</div>';
      btn.textContent = isKo ? 'Ring Studio에서 보기' : 'View in Ring Studio';
      btn.disabled = false;
      btn.dataset.mode = 'ringstudio';
      btn.dataset.ringStudioUrl = cached.ringStudioUrl;
    } else {
      // Not yet generated — show Generate button
      guardPreviewContent.innerHTML =
        '<div class="guard-preview-panel__placeholder">' +
          '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" opacity="0.3">' +
            '<path stroke-linecap="round" stroke-linejoin="round" d="m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909M3.75 21h16.5a1.5 1.5 0 0 0 1.5-1.5V4.5a1.5 1.5 0 0 0-1.5-1.5H3.75a1.5 1.5 0 0 0-1.5 1.5v15a1.5 1.5 0 0 0 1.5 1.5Z"/>' +
          '</svg>' +
          '<p>' + (isKo ? '다이아몬드를 선택하고 Preview를 누르면<br>손 사진에 반지를 합성한 이미지가 표시됩니다' : 'Select a diamond and click Preview<br>to see an AI-composite on your hand') + '</p>' +
        '</div>';
      btn.textContent = isKo ? 'Preview 생성' : 'Generate Preview';
      btn.disabled = false;
      btn.dataset.mode = 'generate';
    }
  }

  // Guard Preview Button — single persistent handler, mode-based
  if (guardPreviewBtn) {
    guardPreviewBtn.addEventListener('click', async function () {
      var btn = document.getElementById('guard-preview-btn');
      if (!btn || !selectedGuardRing) return;

      // Ring Studio mode — open URL
      if (btn.dataset.mode === 'ringstudio') {
        // Always build fresh URL from selected ring to ensure id/variant are included
        var currentRingItem = null;
        for (var ri = 0; ri < guardRingRecommendations.length; ri++) {
          if (guardRingRecommendations[ri].id === selectedGuardRing) {
            currentRingItem = guardRingRecommendations[ri];
            break;
          }
        }
        var rsUrl;
        if (currentRingItem) {
          rsUrl = buildRingStudioUrl(guardAnalysis, 'Select+Setting', {
            settingId: currentRingItem.id,
            settingVariantId: currentRingItem.variantId,
            ringHandle: currentRingItem.handle
          });
        } else {
          rsUrl = btn.dataset.ringStudioUrl || buildRingStudioUrl(guardAnalysis, 'Select+Setting');
        }
        window.open(rsUrl, '_blank');
        return;
      }

      // Generate mode
      if (!guardHandFile) {
        alert(isKo ? '손 사진을 업로드해 주세요' : 'Please upload a hand photo');
        return;
      }

      var selectedItem = null;
      for (var i = 0; i < guardRingRecommendations.length; i++) {
        if (guardRingRecommendations[i].id === selectedGuardRing) {
          selectedItem = guardRingRecommendations[i];
          break;
        }
      }
      if (!selectedItem || !selectedItem.image) return;

      btn.disabled = true;
      btn.textContent = isKo ? 'AI 이미지 생성 중...' : 'Generating AI Preview...';
      guardPreviewContent.innerHTML =
        '<div class="guard-preview-panel__loading">' +
          '<svg width="40" height="40" viewBox="0 0 24 24" fill="none" style="animation:hs-spin 1.5s linear infinite">' +
            '<circle cx="12" cy="12" r="10" stroke="rgba(138,154,142,0.25)" stroke-width="2"/>' +
            '<path d="M12 2a10 10 0 0 1 10 10" stroke="#8a9a8e" stroke-width="2" stroke-linecap="round"/>' +
          '</svg>' +
          '<p>' + (isKo ? 'AI가 이미지를 생성하고 있습니다...' : 'AI is generating your preview...') + '</p>' +
        '</div>';

      try {
        var handDataUrl = await fileToBase64(guardHandFile);
        var handB64 = handDataUrl.replace(/^data:image\/[^;]+;base64,/, '');

        var guardRingDataUrl = await fileToBase64(guardRingFile);
        var guardRingB64 = guardRingDataUrl.replace(/^data:image\/[^;]+;base64,/, '');

        var ringImgResponse = await fetch(selectedItem.image);
        var ringImgBlob = await ringImgResponse.blob();
        var ringB64 = await new Promise(function (resolve) {
          var reader = new FileReader();
          reader.onloadend = function () {
            resolve(reader.result.replace(/^data:image\/[^;]+;base64,/, ''));
          };
          reader.readAsDataURL(ringImgBlob);
        });

        var geminiResponse = await fetch('https://diamond-deal.pages.dev/api/gemini-preview', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            handImage: handB64,
            ringImage: ringB64,
            guardRingImage: guardRingB64,
            ringTitle: selectedItem.title,
            visitor_id: visitorId,
            search_session_id: lastSearchSessionId
          })
        });

        var geminiData = await geminiResponse.json();
        if (!geminiResponse.ok || !geminiData.image) {
          throw new Error(geminiData.error || (isKo ? '이미지 생성에 실패했습니다' : 'Image generation failed'));
        }

        // Cache result — include selected ring setting id/variant
        var ringStudioUrl = buildRingStudioUrl(guardAnalysis, 'Select+Setting', {
          settingId: selectedItem.id,
          settingVariantId: selectedItem.variantId,
          ringHandle: selectedItem.handle
        });
        guardPreviewCache[selectedGuardRing] = { imageB64: geminiData.image, ringStudioUrl: ringStudioUrl };

        // Show image
        guardPreviewContent.innerHTML =
          '<div class="guard-preview-panel__generated">' +
            '<img src="data:image/png;base64,' + geminiData.image + '" alt="AI Generated Preview" />' +
          '</div>';

        btn.textContent = isKo ? 'Ring Studio에서 보기' : 'View in Ring Studio';
        btn.disabled = false;
        btn.dataset.mode = 'ringstudio';
        btn.dataset.ringStudioUrl = ringStudioUrl;

      } catch (err) {
        console.error('Gemini preview error:', err);
        guardPreviewContent.innerHTML =
          '<div class="guard-preview-panel__placeholder">' +
            '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" opacity="0.3">' +
              '<path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"/>' +
            '</svg>' +
            '<p>' + (isKo ? '이미지 생성에 실패했습니다. 다시 시도해 주세요.' : 'Image generation failed. Please try again.') + '</p>' +
          '</div>';
        btn.textContent = isKo ? 'Preview 생성' : 'Generate Preview';
        btn.disabled = false;
        btn.dataset.mode = 'generate';
      }
    });
  }

  // ===== Initialize Guard Upload Zones =====
  handleGuardUpload(guardRingZone, guardRingInput, guardRingPreview, guardRingPreviewImg, guardRingEmpty, guardRingRemove, 'ring');
  handleGuardUpload(guardHandZone, guardHandInput, guardHandPreview, guardHandPreviewImg, guardHandEmpty, guardHandRemove, 'hand');

  if (guardSearchBtn) guardSearchBtn.addEventListener('click', doGuardSearch);

  // ===== Card click → activate (100% opaque) =====
  var allCardInners = document.querySelectorAll('.hero-search__card-inner');
  allCardInners.forEach(function (inner) {
    inner.addEventListener('click', function () {
      inner.classList.add('is-active');
    });
  });

  // ===== Diamond Finder Event Listeners =====
  if (heroCta) {
    heroCta.addEventListener('click', function () {
      openSearch(getSearchOpenMode());
    });
  }
  if (backBtn) backBtn.addEventListener('click', showHero);

  if (uploadZone) {
    if (!uploadZone.getAttribute('tabindex')) uploadZone.setAttribute('tabindex', '0');
    uploadZone.addEventListener('click', function () {
      if (fileInput) fileInput.click();
    });
    uploadZone.addEventListener('dragover', function (e) {
      e.preventDefault();
      uploadZone.classList.add('is-dragover');
      if (searchCard) searchCard.classList.add('is-dragover');
    });
    uploadZone.addEventListener('dragleave', function () {
      uploadZone.classList.remove('is-dragover');
      if (searchCard) searchCard.classList.remove('is-dragover');
    });
    uploadZone.addEventListener('drop', function (e) {
      e.preventDefault();
      uploadZone.classList.remove('is-dragover');
      if (searchCard) searchCard.classList.remove('is-dragover');
      addFiles(Array.from(e.dataTransfer.files));
    });
    // Ctrl+V paste support
    uploadZone.addEventListener('paste', function (e) {
      var file = getImageFromClipboard(e);
      if (file) {
        e.preventDefault();
        addFiles([file]);
      }
    });
  }

  if (fileInput) {
    fileInput.addEventListener('change', function () {
      if (fileInput.files) addFiles(Array.from(fileInput.files));
    });
  }

  if (textInput) {
    textInput.addEventListener('input', updateSearchBtnState);
    textInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        doSearch();
      }
    });
  }

  if (searchBtn) searchBtn.addEventListener('click', doSearch);

  // Global paste: auto-route clipboard image to the appropriate upload zone
  document.addEventListener('paste', function (e) {
    // Skip if already handled by a zone-level paste (defaultPrevented)
    if (e.defaultPrevented) return;

    // Skip if user is typing in a text field
    var tag = (document.activeElement || {}).tagName;
    if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return;

    // Skip if focus is inside an upload zone (zone handler will take care of it)
    var active = document.activeElement;
    if (active && (active.closest && active.closest('.guard-upload-zone'))) return;

    var file = getImageFromClipboard(e);
    if (!file) return;

    // Guard Ring mode is visible
    if (activeMode === 'guard') {
      e.preventDefault();
      if (!guardRingFile && guardRingPreview && guardRingPreviewImg && guardRingEmpty) {
        setGuardFile('ring', file, guardRingPreview, guardRingPreviewImg, guardRingEmpty);
      } else if (!guardHandFile && guardHandPreview && guardHandPreviewImg && guardHandEmpty) {
        setGuardFile('hand', file, guardHandPreview, guardHandPreviewImg, guardHandEmpty);
      }
      return;
    }

    // Diamond Finder mode — search phase visible
    if (heroSlides && heroSlides.classList.contains('is-search') && activeMode === 'diamond') {
      e.preventDefault();
      addFiles([file]);
    }
  });

  // Auto-open search after 4s
  setTimeout(function () {
    if (heroSlides && !heroSlides.classList.contains('is-search')) {
      openSearch(getSearchOpenMode());
    }
  }, 4000);
})();
